import React, {useEffect, useState} from 'react';
import {useParams} from "react-router";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import {toast} from "react-toastify";
import projectUtils from "../../../../../utils/project-utils.js";
import {Template} from "../../../../../components/template/template.jsx";
import Button from "../../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import {Card} from "../../../../../components/card/card.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import organizationService from "../../../../../services/web/organization-service.js";

const OrganizationForm = () => {
    const {id} = useParams();
    const navigate = navigateHook();

    const [state, setState] = useState(null)

    useEffect(() => {
        return () => setState(null);
    }, []);

    const {data, refetch} = useQuery({
        queryFn: () => organizationService.get(id),
        queryKey: ['ecap-organization'],
        enabled: !!id
    });

    useEffect(() => {
        if (!!id && data) {
            setState(data.name);
        } else  {
            setState(null);
        }
    }, [id, data]);

    const submit = () => {
        if (!state) {
            projectUtils.swalErrorMessage("", translateErrMessage("missing.name"), "Ok")
            return;
        }

        let response;
        if (id) response = organizationService.edit(id, {name: state});
        else response = organizationService.create({name: state});

        response
            .then((data) => {
                projectUtils.success(!id);

                if (id) {
                    refetch();
                    return;
                }

                const urlDev = `/ecap-organization/form/${data}`;
                navigate(urlDev);
            })
            .catch((error) => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                if (error.response.status !== 500) {
                    message = translateErrMessage(error.response.data, message);
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            })
    }

    const deleteResponsible = () => {
        projectUtils.swalMessage(
            "warning",
            "Excluir",
            `Excluir organização "${state ?? id}"?`,
            "Sim",
            true,
            "Não",
            ({isConfirmed}) => {
                if (isConfirmed) {
                    organizationService.delete(id)
                        .then(() => {
                            navigate("/ecap-organization");
                            projectUtils.success(true, "Excluído com sucesso");
                        })
                        .catch((error) => {
                            console.error(error);
                            let message = 'Não foi possível excluir.';
                            if (error.response.status !== 500) {
                                message = translateErrMessage(error.response.data, message);
                            }

                            projectUtils.swalErrorMessage('', message, 'Ok')
                        })
                }
            }
        );
    }

    const translateErrMessage = (message, defaultMessage = 'Não foi possível salvar.') => {
        const err = {
            "name.already.registered": "Este \"Nome\" já está sendo utilizado.",
            "missing.name": "O campo \"Nome\" é obrigatório."
        }

        return err[message] ?? defaultMessage
    }

    return (
        <Template>
            <Template.Header>
                <Template.Title>Organização</Template.Title>

                {
                    id &&
                    <Button target={"default"} onClick={() => navigate("/ecap-organization/form")}>
                        <FaPlus /> Adicionar organização
                    </Button>
                }
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body>
                        <InputForm
                            id={"name"}
                            label={"Nome *"}
                            value={state}
                            onChange={({target: {value}}) => setState(value)}
                        />
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body className={"flex justify-end gap-2"}>
                        {
                            id &&
                            <Button
                                target={"danger"}
                                onClick={deleteResponsible}
                                actionFeedbackType='delete'
                                loadingClassName="!text-gray-900 !opacity-100"
                            >

                                Excluir
                            </Button>
                        }
                        <Button
                            onClick={submit}
                            actionFeedbackType='save'
                            loadingClassName="!text-gray-900 !opacity-100"
                            successClassName="!bg-green-700 !text-white !opacity-100"
                        >

                            Salvar
                        </Button>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default OrganizationForm;